import { styled } from "@mui/material/styles";

export const StyledFooter = styled("footer")(() => ({
  display: "flex",
  backgroundColor: "#dbdbdb",
  color: "#8e8e8e",
  marginTop: "auto",
  fontSize: "10px",
  paddingLeft: 16,
}));

export const FooterElement = styled("span")(() => ({
  display: "flex",
  alignItems: "center",
  padding: 8,
  fontSize: 12,
  borderLeft: "1px solid #bfbfbf",
}));
